import * as constants from './constants';
import { initialState } from './states';

/**
 * reducer
 */
export default (state = initialState, action) => {
    switch (action.type) {
        case constants.LOGIN_REQUEST:
            return {
                ...state,
                loading: true
            };
        case constants.LOGIN_FAIL:
            return {
                ...state,
                loading: false
            };
        case constants.LOGIN_SUCCESS:
            return {
                ...state,
                ...action.data,
                loading: false,
                isLogin: true
            };
        case constants.LOGIN_LOGOUT:
            return {
                ...state,
                isLogin: false,
                iUserId: 0,
                sUserAccount: '',
                sUserName: '',
                sPhotoPath: '',
                iSupplierId: 0,
                sJobTitle: '',
                sCompanyName: '',
                isAdmin: 0,
                isAllCandidate: 0,
                isReport: 0,
                sLastLoginDateTime: ''
            };
        case constants.CHANGE_USER_INFO:
            return {
                ...state,
                ...action.data
            };
        default:
            break;
    }
    return state;
};
